import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { User } from 'services/user/models/user-interface';
import { downloadCertificate } from 'services/certificate';
import CertificateIcon from 'assets/icon/icone check.svg';
import CertificateIconButton from 'assets/icon/icone certificado.svg'
import { CertificateVerifyContainer } from './style';

interface ICertificateVerify {
  user: User;
  trailId: string;
}

const CertificateVerify: React.FC<ICertificateVerify> = ({ user, trailId }) => {
  const [hasCertificate, setHasCertificate] = useState<boolean>(true);
  const location = useLocation();

  useEffect(() => {
    (async () => {
      try {
        const response = await downloadCertificate(trailId, false);
        setHasCertificate(response);
      } catch {
        setHasCertificate(false);
      }
    })();
  }, [trailId]);

  useEffect(() => {
    if (location.state === 'certificate') {
      document.getElementById('certificate-container')?.scrollIntoView();
    }
  }, [location]);

  const handleCertificateDownload = async () => {
    await downloadCertificate(trailId, true);
  };

  return (
    <CertificateVerifyContainer id="certificate-container">
      <h1>CERTIFICADO</h1>

      <div className="certificate-box">
        <img src={CertificateIcon} alt="certificate" className="certificate-icon" />

        {hasCertificate ? (
          <p>
            <span>{user.name}</span>, você atingiu o número de horas necessário
            para realizar o download do certificado
          </p>
        ) : (
          <p>
            <span>{user.name}</span>, você precisa atingir no mínimo{' '}
            <span>03 horas</span> de curso para emitir seu certificado.
            Assista mais aulas, e volte aqui para emitir seu certificado.
          </p>
        )}

        <div className={`certificate-btn ${hasCertificate ? '' : 'disable'}`}>
          <button disabled={!hasCertificate} onClick={handleCertificateDownload}>
            <img src={CertificateIconButton} alt="certificate" /> GERAR CERTIFICADO
          </button>
        </div>
      </div>
    </CertificateVerifyContainer>
  );
};

export default CertificateVerify;
